import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,_vm._g(_vm._b({attrs:{"ripple":"","two-line":""}},'v-list-item',_vm.$attrs,false),_vm.$listeners),[_c(VListItemContent,{staticClass:"py-1"},[_c(VListItemTitle,{attrs:{"data-test":"ContactRecordTag"},domProps:{"textContent":_vm._s(_vm.contact.RecordTag)}}),_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.subtitle))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }